import { useState, useEffect } from 'react';
import { useStoreState } from 'easy-peasy';
import client from '../../../../utils/apolloClient';
import { companySummaryQuery } from '../services/companySummaryQueries';

const useCompanySummary = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { userId } = useStoreState(state => state.auth);

  useEffect(() => {
    if (!userId) return;
    setLoading(true);
    client.clientPrivate
      .query({
        query: companySummaryQuery,
        variables: { input: { user_id: userId } },
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        setSummary(data.company_summary);
        setLoading(false);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
      });
  }, [userId]);

  return { summary, loading, error };
};

export default useCompanySummary;
